export type NavLink = {
  label: string
  href: string
}

export const navLinks: NavLink[] = [
  { label: 'The lab', href: '#lab' },
  { label: 'Difference', href: '#difference' },
  { label: 'The studio', href: '#story' },
]

/**
 * PLACEHOLDER PORTFOLIO ENTRIES.
 * These three slots are intentionally empty and easy to replace.
 * Fill in `name`, `icon`, `screenshot`, `description` and `storeURL` when
 * an app is ready to share. Leave the fields as empty strings until then —
 * the UI falls back to the neutral label and "Coming soon".
 */
export type AppPlaceholder = {
  slot: string
  label: string
  name: string
  icon: string
  screenshot: string
  description: string
  storeURL: string
  /** Optional extras shown once an app is real. */
  subheading?: string
  platform?: string
  imageAlt?: string
}

export const appPlaceholders: AppPlaceholder[] = [
  {
    slot: '01',
    label: 'App 01',
    name: 'Lightning Learn',
    icon: '',
    screenshot:
      'https://cdn.magicpatterns.com/uploads/qMBNq7q1bQGTuWM7p6J2WV/lightning-learn-showcase-v1.png',
    subheading: '160+ adventures. A world to discover.',
    description:
      'From wild weather and the human body to animals, history, and beyond—kids can read or listen, test what they’ve learned, and collect badges along the way.',
    platform: 'Made for iOS',
    imageAlt:
      'Lightning Learn on two iPhones: an illustrated Dinosaur Days adventure with a read-to-me option, and a Dino Tooth Tracker badge earned, with the app’s fox guide.',
    storeURL: '',
  },
  {
    slot: '02',
    label: 'App 02',
    name: '',
    icon: '',
    screenshot: '',
    description: '',
    storeURL: '',
  },
  {
    slot: '03',
    label: 'App 03',
    name: '',
    icon: '',
    screenshot: '',
    description: '',
    storeURL: '',
  },
]

export type Principle = {
  title: string
  caption: string
}

/** The four-item strip beneath the hero. */
export const principles: Principle[] = [
  { title: 'Original ideas', caption: 'Apps with a clear reason to exist.' },
  { title: 'Everyday value', caption: 'Something useful, fun or worth coming back to.' },
  { title: 'Focused portfolio', caption: 'Fewer projects. More attention to each.' },
  { title: 'High standards', caption: 'Built to work as well as they look.' },
]

export type Differentiator = {
  title: string
  detail: string
}

export const differentiators: Differentiator[] = [
  {
    title: 'An idea worth building',
    detail: 'Every app starts with something we want to make better, easier or more fun.',
  },
  {
    title: 'A point of view',
    detail:
      'Products with their own identity, from the first screen to the smallest interaction.',
  },
  {
    title: 'Easy to get into',
    detail: 'Get to the good part quickly. Keep the experience clear.',
  },
  {
    title: 'Depth where it counts',
    detail: 'Put the effort into the features people actually use.',
  },
  {
    title: 'Room to explore',
    detail: 'Learning, lifestyle and gaming. We follow strong ideas across categories.',
  },
  {
    title: 'Built for the long run',
    detail: 'Launch is the beginning. We keep improving the apps we put into the world.',
  },
]

export type FaqItem = {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'What kinds of apps do you build?',
    answer:
      'Original apps across learning, lifestyle and gaming. Each has its own purpose and personality.',
  },
  {
    question: 'Who are they built for?',
    answer:
      'Our apps are built for people in the United States. The audience and experience are specific to each product.',
  },
  {
    question: 'What matters most?',
    answer:
      'Real value, a great experience and reliable quality. User feedback helps us decide what to improve next.',
  },
  {
    question: 'Why Black Comet?',
    answer:
      'The name is a tribute to the founder’s black cat. He lives on as the studio’s mascot.',
  },
]
